import { RootState } from '../../../../../store/reducers';
import { PrivacyDto } from './privacy.dto';

export const selectPrivacyConditions = (state: RootState): PrivacyDto => state.privacy;
